import { render } from "./AuthModal.vue?vue&type=template&id=58dd2378&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"

import "./AuthModal.vue?vue&type=style&index=0&id=58dd2378&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dd2378"]])

export default __exports__